export const defaults = {
  profileImage: "/assets/img/anonymous.png",
  chipsets: [
    [1, 5, 25, 100, 500],
    [5, 25, 100, 500, 1000],
    [25, 100, 500, 1000, 5000],
    [100, 500, 1000, 5000, 25000],
  ],
  chipColors: [
    [
      { p: "#f5f5f5", s: "#2471a3" },
      { p: "#c0392b", s: "#f5f5f5" },
      { p: "#27ae60", s: "#f5f5f5" },
      { p: "#1c1c1c", s: "#f5f5f5" },
      { p: "#14438f", s: "#f5f5f5" },
    ],
    [
      { p: "#c0392b", s: "#f5f5f5" },
      { p: "#27ae60", s: "#f5f5f5" },
      { p: "#1c1c1c", s: "#f5f5f5" },
      { p: "#14438f", s: "#f5f5f5" },
      { p: "#7d3c98", s: "#f5f5f5" },
    ],
    [
      { p: "#27ae60", s: "#f5f5f5" },
      { p: "#1c1c1c", s: "#f5f5f5" },
      { p: "#14438f", s: "#f5f5f5" },
      { p: "#7d3c98", s: "#f5f5f5" },
      { p: "#e67e22", s: "#f5f5f5" },
    ],
    [
      { p: "#1c1c1c", s: "#f5f5f5" },
      { p: "#14438f", s: "#f5f5f5" },
      { p: "#7d3c98", s: "#f5f5f5" },
      { p: "#e67e22", s: "#f5f5f5" },
      { p: "#e91e8c", s: "#f5f5f5" },
    ],
  ],
  chipDesigns: ["dice", "striped", "classic", "blades"],
  tournDefaults: {
    buyin: 10,
    chipset: [25, 100, 500, 1000, 5000],
    expPlayers: 9,
    actPlayers: 9,
    duration: 5,
    managePayouts: true,
    manageRegistrations: true,
    antes: false,
    anteType: "big_blind_ante",
    rebuys: false,
    initSmallBlind: 5,
    startingStack: 10000,
    tournamentType: "freezeout",
    reentryRatio: 0.333,
    rebuyRatio: 1,
    addonRatio: 0.75,
    addonChipsRatio: 1.5,
    perTable: 9,
  },
  bvLogo: "/assets/img/logo.png",
};
